<!-- NOTE Navbar -->
<nav class="navbar navbar-expand-lg">
  <div class="header">
    <div class="top">
      <div class="left">
        <div class="company-switcher">
          <div
            class="company-badge"
            [suiPopoverTrigger]="companySwitcherPopover"
            #companySwitcherRef="suiPopoverTrigger"
          >
            <!-- Active Company Initials  -->
            <div class="active-company">
              <app-company-badge
                [companyName]="activeCompany"
              ></app-company-badge>
            </div>
            <fa-icon [icon]="['fas', 'grid']"></fa-icon>
          </div>
          <!-- Dropdown Menu  -->
          <ng-template #companySwitcherPopover>
            <div
              suiPopover
              class="dropdown-menu"
              aria-labelledby="dropdownMenuButton"
            >
              <app-company-switcher
                [activeCompany]="activeCompany"
                [accessLevel]="accessLevel"
                (companySelected)="companySwitcherRef.close()"
              ></app-company-switcher>
            </div>
          </ng-template>
        </div>
        <a class="brand" [routerLink]="['analytics', 'home']">
          <img [src]="'assets/img/logo.svg'" alt="Sensika Logo" />
        </a>
        <div class="navigate">
          <app-search-suggest></app-search-suggest>
        </div>
        @if (userFacade.hasPermissionSync(AppComponents.CREATE_MENU_ROOT)) {
          <div class="create-new">
            <sui-button
              size="sm"
              variant="legacy-ghost"
              [leadingIcon]="['fas', 'plus']"
              [trailingIcon]="['fas', 'caret-down']"
              [expanded]="createNewDropdownRef.isOpen()"
              [suiMenuTrigger]="createNewMenu"
              suiMenuPlacement="bottom-end"
              #createNewDropdownRef="suiMenu"
            >
              {{ "header.button.create-new" | translate }}
            </sui-button>
            <ng-template #createNewMenu>
              <sui-menu>
                @if (
                  userFacade.hasPermissionSync(AppComponents.WORKSPACE_ROOT)
                ) {
                  <button sui-menu-item (click)="createNewWorkspace()">
                    <fa-icon [icon]="['fas', 'folder']"></fa-icon>
                    <span>{{
                      "header.create-new-dropdown.workspace" | translate
                    }}</span>
                  </button>
                }
                @if (userFacade.hasPermissionSync(AppComponents.FEED_ROOT)) {
                  <button sui-menu-item (click)="createNewFeed()">
                    <fa-icon [icon]="['fas', 'feed']"></fa-icon>
                    <span>{{
                      "header.create-new-dropdown.feed" | translate
                    }}</span>
                  </button>
                }
                @if (
                  userFacade.hasPermissionSync(AppComponents.DASHBOARD_ROOT)
                ) {
                  <button sui-menu-item (click)="createNewDashboard()">
                    <fa-icon [icon]="['fas', 'chart-pie']"></fa-icon>
                    <span>{{
                      "header.create-new-dropdown.dashboard" | translate
                    }}</span>
                  </button>
                }
                @if (
                  userFacade.hasPermissionSync(AppComponents.DIMENSION_ROOT)
                ) {
                  <button sui-menu-item (click)="createNewDimension()">
                    <fa-icon [icon]="['fas', 'layer-group']"></fa-icon>
                    <span>{{
                      "header.create-new-dropdown.dimension" | translate
                    }}</span>
                  </button>
                }
                <!--
                Use Case creator is restricted to GLOBAL_ADMIN and above
                (access_level >= 50) for now. ADR 0002's 'Use Case Provisioning'
                feature-component gate still applies server-side; this entry
                point additionally requires global-admin until the feature is
                GA'd to regular users.
                -->
                @if (isGlobalAdmin$ | async) {
                  <button sui-menu-item (click)="createNewUseCase()">
                    <fa-icon [icon]="['fas', 'wand-magic-sparkles']"></fa-icon>
                    <span>{{
                      "header.create-new-dropdown.use-case" | translate
                    }}</span>
                  </button>
                }
              </sui-menu>
            </ng-template>
          </div>
        }
      </div>
      <div class="right">
        <div class="nav-menus">
          <div class="menu" (click)="toggleDarkMode()">
            <span class="header-dropdown-toggle"
              ><fa-icon [icon]="['fas', 'lightbulb']"></fa-icon
            ></span>
            <span class="arrow"></span>
          </div>

          <div
            class="menu"
            [class.active]="activeMenu == 'alerts'"
            (click)="showAlerts()"
          >
            <span class="header-dropdown-toggle">
              <fa-icon [icon]="['fas', 'bell']"></fa-icon>
            </span>
            @if (countAlerts() > 0) {
              <span class="notifier">{{ countAlerts() }}</span>
            }
            <div #alertsDropdownContainer class="dropdown-container"></div>
          </div>

          <div
            class="menu"
            [class.active]="activeMenu == 'notifications'"
            (click)="showNotifications()"
          >
            <span class="header-dropdown-toggle">
              <fa-icon [icon]="['fas', 'flag']"></fa-icon>
            </span>
            @if (countNotifications() > 0) {
              <span class="notifier">{{ countNotifications() }}</span>
            }
            <div
              #notificationsDropdownContainer
              class="dropdown-container"
            ></div>
          </div>

          <div
            class="menu"
            [class.active]="activeMenu == 'user'"
            (click)="showUserSettings()"
          >
            <ng-container>
              <a>
                <img
                  class="avatar"
                  [src]="(currentUser$ | async).avatar_url"
                  alt=""
                />
              </a>

              <div #userDropdownContainer class="dropdown-container"></div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom">
      <app-breadcrumb></app-breadcrumb>
      @if (currentObject$ | async; as currentObject) {
        <div class="objects-tools">
          @if (currentObject.object_class_id === NomObjectClass.DASHBOARD) {
            <sui-button
              variant="primary"
              size="md"
              [leadingIcon]="['fas', 'chalkboard-user']"
              (click)="showPresentationMode($any(currentObject))"
            >
              {{ "header.button.present" | translate }}
            </sui-button>
          }
          @if (currentObject.object_class_id === NomObjectClass.FEED) {
            <app-feed-views></app-feed-views>
          }
          @if (currentObject) {
            <div class="date-picker">
              @if (
                currentObject.object_class_id === NomObjectClass.FEED ||
                currentObject.object_class_id === NomObjectClass.DASHBOARD
              ) {
                <app-datepicker-range
                  [context]="currentObject.object_class_id"
                ></app-datepicker-range>
              }
            </div>
          }
        </div>
      }

      <!-- Screen-registered controls (HeaderToolsService): any screen can show a
      Data View toggle + date range here without the header knowing about it -->
      @if (headerTools$ | async; as tools) {
        <div class="objects-tools">
          @if (tools.dataView; as dataView) {
            <div class="view-selector">
              <span>{{ "feed-views.label.data-view" | translate }}:</span>
              <sui-button
                variant="ghost"
                size="xsm"
                [leadingIcon]="['fas', 'chart-column']"
                [iconOnly]="true"
                [pressed]="(dataView.open$ | async) ?? false"
                [ariaLabel]="'feed-views.label.data-view' | translate"
                (click)="dataView.toggle()"
              ></sui-button>
            </div>
          }
          @if (tools.dateRange; as dateRange) {
            <div class="date-picker">
              <app-datepicker-range
                [context]="dateRange.context"
                [lockPeriod]="dateRange.lockPeriod ?? true"
              ></app-datepicker-range>
            </div>
          }
        </div>
      }
    </div>
  </div>
</nav>

<!-- NOTE Content -->
<ng-content></ng-content>
